export const xTokenPlaceholder = '{{xToken}}';
export const urlPlaceholder = '{{url}}';

export const grpcCodeExampleTemplate = `grpcurl \\\n  -H "x-token: ${xTokenPlaceholder}" \\\n  ${urlPlaceholder} list`;
